import { InboxArrowDownIcon } from './InboxArrowDownIcon';

/**
 * author: Google
 * id A20D1ABC-DD99-404B-8BEE-967BB1C636B0
 * name inbox-arrow-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/inbox-arrow-down.svg
 * tags
 */
export const MoveToInboxIcon = InboxArrowDownIcon;
export default MoveToInboxIcon